export default "__VITE_ASSET__DNSFEy$i__"